import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { icon, image, title, price, features } = plan; // Extracting data from plan

  return (
    <div className="price-item">

      <div className='intro'>
        <img src={image} alt={title} />
        <div className='intro-content'>
          <div className='top-icon'>{icon}</div> {/* Dynamic Icon */}
          <h3>{title}</h3> {/* Plan Title */}
          <span></span>
          <div className="price">${price}</div> {/* Plan Price */}
          <p>/ month</p>
        </div>
      </div>

      <div className='content'>

        {/* List of Features */}
        <ul>
          {features.map((feature, index) => (
            <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
          ))}
        </ul>

        <Button link={"Contact-us"} title={"Join Now"} />

      </div>

    </div>
  );
};

export default Plan;